import labelTranslation from './labelTranslation'

const recurrence = {
  labelTranslation,
}

export default recurrence
